<template>
  <b-dropdown
    variant="success"
    class="w-100"
    :text="isLoading ? 'Downloading...' : 'Download Report'"
    :disabled="isLoading"
  >
    <b-dropdown-text v-if="!options.length" class="small text-muted">
      {{ isLoadingOptions ? 'Loading...' : 'No reports available' }}
    </b-dropdown-text>

    <template v-else>
      <b-dropdown-form class="px-1">
        <div v-for="opt in options" :key="opt.key" class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              :id="`${_uid}-${opt.key}`"
              v-model="selected[opt.key]"
            >
            <label class="custom-control-label" :for="`${_uid}-${opt.key}`">{{ opt.label }}</label>
          </div>
        </div>
      </b-dropdown-form>

      <b-dropdown-divider></b-dropdown-divider>
      <div class="mx-1">
        <b-button variant="primary" block class="mb-1" size="sm" :disabled="isLoading" @click="download()">
          Download
        </b-button>
        <b-button variant="primary" block class="mb-1" size="sm" :disabled="isLoading" @click="downloadAll">
          Download All
        </b-button>
      </div>
    </template>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import ReportSvc from '@/services/ReportSvc';

export default {
  name: 'ReportDownloadDropdown',
  data() {
    return {
      options: [],
      selected: {},
      isLoading: false,
      isLoadingOptions: false,
    };
  },
  computed: {
    ...mapGetters('filter', ['date', 'currentMassId']),
  },
  watch: {
    currentMassId: { immediate: true, handler: 'loadOptions' },
  },
  methods: {
    async loadOptions() {
      if (!this.currentMassId) {
        this.setOptions([]);
        return;
      }

      this.isLoadingOptions = true;
      try {
        this.setOptions(await ReportSvc.getReportList(this.currentMassId));
      } catch (error) {
        // ponytail: apapun gagalnya (device nggak ada, network) -> "No reports available".
        // Pisahin pesannya kalau nanti kebanyakan ketuker sama error beneran.
        console.error('Error loading report list:', error);
        this.setOptions([]);
      } finally {
        this.isLoadingOptions = false;
      }
    },
    // selected direset barengan options: key report beda-beda antar asset,
    // dan assign objek baru bikin key-nya reaktif di Vue 2.
    setOptions(options) {
      this.options = options;
      this.selected = Object.fromEntries(options.map((opt) => [opt.key, false]));
    },
    // keys dikirim eksplisit sama downloadAll biar nggak perlu nyentang `selected` beneran
    async download(keys) {
      const reports = keys || Object.keys(this.selected).filter((key) => this.selected[key]);

      if (!reports.length) {
        this.$toast.warning('No options selected');
        return;
      }

      this.isLoading = true;
      try {
        const { blob, filename } = await ReportSvc.getReports(
          this.date.start.unix(),
          this.date.end.unix(),
          this.currentMassId,
          reports,
        );
        saveAs(blob, filename);
      } catch (error) {
        console.error('Error downloading report:', error);
        this.$toast.error('Failed to download report');
      } finally {
        this.isLoading = false;
      }
    },
    downloadAll() {
      this.download(this.options.map((opt) => opt.key));
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0 !important;
}
</style>
